
import { useEffect, useState } from 'react'
import url from '../api/url'
import { elToast } from '../functions/Alerta'
import { useEmpleadoStore } from '../stores/useEmpleadoStore'

const useLentes = () => {

    // variables
    const { URL } = url()
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const [usaLentes, setUsaLentes] = useState( 0 )
    const [graduacion, setGraduacion] = useState( '' )
    const [cargando, setCargando] = useState( false )
    const [cargaPagina, setCargaPagina] = useState( false )
    const [mostrarGuardar, setMostrarGuardar] = useState(true)



    // funciones
    const guardar = () => {

        if ( !usaLentes ) return
        if ( graduacion.trim().length === 0 ) {
            elToast( 'Debes indicar una graduación', 'info' )
            return
        }

        setCargando( true )
        let aaa = { graduacion, funcion: 'guardarLentes', correo: objLogueado.email }

        fetch( URL, {
            method: 'post',
            body: JSON.stringify( aaa )
        })
        .then( res => res.json() )
        .then( function (d) {
            if ( d.codigo === 1 ) {
                elToast( d.mensaje )
                setMostrarGuardar(false)
            } else {
                elToast( d.mensaje, 'error' )
            }
        })
        .catch( a => {
            elToast( "Error al guardar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.", "error" )
            // alert("")
        })
        .finally( () => setCargando( false ) )
    }

    const traerLentes = () => {

        var fd = new FormData()
        fd.append("funcion", "traerLentes")
        fd.append("email", objLogueado.email)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            if ( e.graduacion?.length > 0 ) {

                setUsaLentes( true )
                setGraduacion( e.graduacion )
                setMostrarGuardar(false)
            }
        })
        .catch( a => {
            elToast( 'Hay problemas al traer la información de tus lentes', 'error' );
        })
        .finally( () => setCargaPagina( true ) );
    }

    const eliminarLentes = () => {

        var fd = new FormData()
        fd.append("funcion", "eliminarLentes")
        fd.append("email", objLogueado.email)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            if ( e.codigo === 1 ) {
                elToast( e.mensaje )
                setGraduacion('')
            } else {
                elToast( e.mensaje, 'error' )
            }
        })
        .catch( a => {
            elToast( 'Hay problemas al actualizar la información de tus lentes', 'error' );
        })
    }



    // useEffect
    useEffect(() => {
        if ( cargaPagina && usaLentes === false ) {
            eliminarLentes()
        }
        if (usaLentes === true) {
            setMostrarGuardar(true)
        }
        // eslint-disable-next-line
    }, [ usaLentes ])

    useEffect(() => {
        traerLentes()
        // eslint-disable-next-line
    }, [])




    return {
        usaLentes, setUsaLentes, graduacion, setGraduacion, cargando, guardar,
        mostrarGuardar, setMostrarGuardar
    }
}

export default useLentes
